import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import { Provider } from 'react-redux';

import { store } from './app/store';

import subscribeRecord from './utils/subscribeRecord';

import App from './app/App';

import { Analytics } from "@vercel/analytics/react";

subscribeRecord(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
    <Analytics />
  </Provider>
);
